<template>
	<div class="home">
		<header>
            <Header />
        </header>
		<main class="news-box">
            <!-- news search -->
            <section class="news-grid">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-xl-2">
                            <el-select v-model="headerData.cate" @change="handleCate" clearable class="handle-select" placeholder="请选择新闻分类">
                                <el-option
                                v-for="item in headerData.optionCate"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="col-12 col-xl-8 mt10">
                            <el-input placeholder="搜索新闻关键词" class="handle-input" v-model="headerData.newsValue" clearable></el-input>
                            <el-button type="primary" icon="el-icon-search" @click="getSearchList">搜索</el-button>
                        </div>
                    </div>
                    <div class="row news-grid-item">
                        <div class="col-12 col-xl-4">
                            <div class="grid-item-data">
                                <div class="grid-data-title">时间范围:</div>
                                <div class="grid-data-info" :class="{'active':headerData.timeSwitch == 1}" @click="handleTime(1)">最近一周</div>
                                <div class="grid-data-info" :class="{'active':headerData.timeSwitch == 2}" @click="handleTime(2)">最近一月</div>
                                <div class="grid-data-info" :class="{'active':headerData.timeSwitch == 3}" @click="handleTime(3)">最近三月</div>
                            </div>
                        </div>
                        <div class="col-12 col-xl-8">
                            <div class="grid-item-data">
                                <div class="grid-data-title">新闻来源:</div>
                                <div class="grid-data-info" :class="{'active':headerData.sourceSwitch == '1'}" @click="handleSource('1')">全部</div>
                                <div class="grid-data-info" :class="{'active':headerData.sourceSwitch == '2'}" @click="handleSource('2')">政策解读</div>
                                <div class="grid-data-info" :class="{'active':headerData.sourceSwitch == '3'}" @click="handleSource('3')">市场动态</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- news list -->
            <section class="news-list mt20">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="news-wrapper-title">行业新闻</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 news-wrapper-item" v-for="(item,index) in newsData" :key="index">
                            <div class="news-title">
                                <div class="news-title-data" @click="routeDetail(item.id)">{{ item.newsTitle }}</div>
                                <div class="news-date">{{ item.insertTime }}</div>
                            </div>
                            <div class="news-brief">{{ item.newsContent }}</div>
                            <span class="news-link">{{ item.newsCate }}</span>
                        </div>
                        <div v-if="newsData.length == 0">
                            <el-empty description="暂无数据"></el-empty>
                        </div>
                        
                    </div>
                    <div class="row ">
                        <div class="pagination  mb-2">
                            <el-pagination
                                background
                                @current-change="handleCurrentChange"
                                :current-page="query.pageIndex"
                                :page-size="query.pageSize"
                                layout="total, prev, pager, next, jumper"
                                :total="query.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </section>
		</main>
		<!-- <footer><Footer /></footer> -->
	</div>
</template>

<script>
import Header from '../../components/header.vue';
// import Footer from '../../components/footer.vue';
import { newsList } from '@/api/index';
export default {
  	name: 'Home',
	components: {
		Header,
		// Footer
	},
	data() {
		return {
            headerData:{
                cate:"",
                optionCate:[
                    {value: '政策解读', label: '政策解读'},
                    {value: '行业报告', label: '行业报告'},	
                    {value: '技术创新', label: '技术创新'},	
                    {value: '市场动态', label: '市场动态'},	
                    {value: '技术应用', label: '技术应用'},	
                    {value: '产业发展', label: '产业发展'},	
                ],
                newsValue:"",
                timeSwitch:"",
                sourceSwitch:'1',
            },
			newsData:[],
            query:{
                pageIndex:1,
                pageSize:10,
                total:0,
            }
		};
		
		
	},
	mounted() {
        this.getNewsList()
	},
    methods:{
        //获取新闻列表
        async getNewsList(){
            const param = {
                pageNum:this.query.pageIndex,
                pageSize:this.query.pageSize,
                newsCate:this.headerData.cate,
                newsResource:this.headerData.sourceSwitch === '1' ? '' : this.headerData.sourceSwitch === '2' ? '政策解读' : this.headerData.sourceSwitch === '3' ? '市场动态' : '',
                timeType:this.headerData.timeSwitch,
                newsTitle:this.headerData.newsValue
            }
            const data = await newsList(param);
            this.newsData = data.data.records;
            this.query.total = data.data.total;
        },
        getSearchList(){
            this.query.pageIndex = 1;
            this.getNewsList();
        },
        handleCate(){
            this.query.pageIndex = 1;
            this.getNewsList();
        },
        handleTime(val){
            this.headerData.timeSwitch = val;
            this.query.pageIndex = 1;
            this.getNewsList();
        },
        handleSource(val){
            this.headerData.sourceSwitch = val;
            this.query.pageIndex = 1;
            this.getNewsList();
        },
        handleCurrentChange(val) {
            this.query.pageIndex = val;
            this.getNewsList();
        },
        routeDetail(id){
            sessionStorage.setItem('newsId',id);
            this.$router.push({path:'/newsDetail'})
        }
    }
}
</script>
<style lang="scss" scoped>
header {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0 0.2rem 0.6rem 0 #0000001a;
    position: sticky;
    top: 0;
    z-index: 99;
}
.news-box{
    width: 100%;
    height:auto;
    min-height:100vh;
    background-color: #f9fafb;
}
.news-grid{
    width: 100%;
    height:auto;
    padding:20px 0 20px;
	background-color: #fff;
    .news-grid-item{
        width:100%;
        height:auto;
        display: flex;
        justify-content:left;
        cursor:default;
        .grid-item-data{
            width:auto;
            height:100%;
            line-height:40px;
            font-size:14px;
            margin-top:10px;
            .grid-data-title{
                display:inline-block;
                margin-right:10px;
            }
            .grid-data-info{
                display:inline-block;
                margin-right:10px;
                padding:0 8px;
                border-radius:5px;
                font-size:14px;
                transition:0.5s;
                background-color: #f8f8f8;
                cursor:pointer;
            }
            .grid-data-info.active{
                color:#fff;
                background-color: #409EFF;
            }
        }
    }
}
.news-list{
    width: 100%;
    height:auto;
    background-color: #fff;
    cursor:default;
    .news-wrapper-title{
        box-sizing:border-box;
        padding:20px 10px;
        font-size:20px;
        font-weight:600;
        letter-spacing: 2px;
    }
    .news-wrapper-item{
        width:100%;
        height:auto;
        box-sizing:border-box;
        padding:20px 20px;
        border-bottom:1px solid #e5e7eb;
        .news-title{
            width:100%;
            height:auto;
            margin-bottom:10px;
            display:flex;
            justify-content:space-between;
            .news-title-data{
                font-size:17px;
                color:#333;
            }
            .news-title-data:hover{
                color:#409EFF;
                cursor:pointer;
            }
            .news-date{
                font-size:12px;
                color:#999;
            }
        }
        .news-brief{
            width:100%;
            height:auto;
            font-size:14px;
            color:#666;
            margin-bottom:10px;
        }
        .news-link{
            width:auto;
            font-size:13px;
            box-sizing: border-box;
            padding:5px 10px;
            color:#409EFF;
            border-radius:5px;
            background-color: #dbeafe;
        }
    }
}
</style>

<style  scoped>
.handle-input{
    width:600px;
    margin-right:10px;
}
</style>
